export default {
  title: {
    en: 'Statistics',
  },
  stats: {
    // soccer start
    attacks: {
      en: 'Attacks',
    },
    dangerousAttacks: {
      en: 'Dangerous Attacks',
    },
    possession: {
      en: 'Possession',
    },
    penalties: {
      en: 'Penalties',
    },
    corners: {
      en: 'Corners',
    },
    yellowCards: {
      en: 'Yellow Cards',
    },
    redCards: {
      en: 'Red Cards',
    },
    totalShots: {
      en: 'Total Shots',
    },
    shotsOnTarget: {
      en: 'Shots on Target',
    },
    shotsOffTarget: {
      en: 'Shots off Target',
    },
    throwIns: {
      en: 'Throw-Ins',
    },
    freeKicks: {
      en: 'Free Kicks',
    },
    substitutions: {
      en: 'Substitutions',
    },
    actionArea: {
      en: 'Action Area',
    },
    expectedGoals: {
      en: 'Expected Goals (xG)',
    },
    passes: {
      en: 'Passes',
    },
    goalkeeperSaves: {
      en: 'Goalkeeper Saves',
    },
    passingAccuracy: {
      en: 'Passing Accuracy',
    },
    crosses: {
      en: 'Crosses',
    },
    offsides: {
      en: 'Offsides',
    },
    ballSafe: {
      en: 'Ball Safe',
    },
    shotsBlocked: {
      en: 'Shots Blocked',
    },
    injuryBreaks: {
      en: 'Injury Breaks',
    },
    missedPenalties: {
      en: 'Missed Penalties',
    },
    kickoffs: {
      en: 'Kickoffs',
    },
    // soccer end
    // basketball start
    fouls: {
      en: 'Fouls',
    },
    freeThrows: {
      en: 'Free Throws',
    },
    freeThrowsScoredPerc: {
      en: 'Free Throws Scored Percentage',
    },
    twoPointers: {
      en: 'Two Pointers',
    },
    threePointers: {
      en: 'Three Pointers',
    },
    timeoutsTaken: {
      en: 'Timeouts Taken',
    },
    timeoutsRemaining: {
      en: 'Timeouts Remaining',
    },
    jumpBalls: {
      en: 'Jump Balls',
    },
    assists: {
      en: 'Assists',
    },
    offensiveRebounds: {
      en: 'Offensive Rebounds',
    },
    defensiveRebounds: {
      en: 'Defensive Rebounds',
    },
    totalRebounds: {
      en: 'Total Rebounds',
    },
    turnovers: {
      en: 'Turnovers',
    },
    steals: {
      en: 'Steals',
    },
    blocks: {
      en: 'Blocks',
    },
    playersDisqualified: {
      en: 'Players Disqualified',
    },
    // basketball end
    // tennis start
    serviceFaults: {
      en: 'Service Faults',
    },
    doubleFaults: {
      en: 'Double Faults',
    },
    aces: {
      en: 'Aces',
    },
    breakPoints: {
      en: 'Break Points',
    },
    breakPointsConversion: {
      en: 'Break Points Conversion',
    },
    winFirstServePerc: {
      en: 'Win First Serve Percentage',
    },
    winSecondServePerc: {
      en: 'Win Second Serve Percentage',
    },
    pointsOnOwnServe: {
      en: 'Points on Own Serve',
    },
    totalPointsWon: {
      en: 'Total Points Won',
    },
    // tennis end
    // volleyball start
    longestStreak: {
      en: 'Longest Streak',
    },
    pointsWonOnOwnServe: {
      en: 'Points Won on Own Serve',
    },
    pointsWonOnOpponentServe: {
      en: 'Points Won on Opponent Serve',
    },
    serviceErrors: {
      en: 'Service Errors',
    },
    // volleyball end
  },
}
